import React from 'react';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Area,
  AreaChart
} from 'recharts';
import { GrowthTrend } from '../../types/dashboard';

interface GrowthChartProps {
  data: GrowthTrend[] | undefined;
  loading?: boolean;
}

const GrowthChart: React.FC<GrowthChartProps> = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body">
          <h6 className="card-title text-muted mb-3">Growth (30 days)</h6>
          <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 260 }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (!data || data.length === 0) {
    return (
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body">
          <h6 className="card-title text-muted mb-3">Growth (30 days)</h6>
          <div className="d-flex align-items-center justify-content-center text-muted" style={{ minHeight: 260 }}>
            No data
          </div>
        </div>
      </div>
    );
  }
  const chartData = data.map((d) => ({
    ...d,
    shortDate: d.date.slice(5)
  }));
  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body">
        <h6 className="card-title text-muted mb-3">Growth (30 days)</h6>
        <ResponsiveContainer width="100%" height={260}>
          <AreaChart data={chartData} margin={{ top: 5, right: 5, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
            <XAxis dataKey="shortDate" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip
              labelFormatter={(_, payload) => payload?.[0]?.payload?.date}
              formatter={(value) => [value ?? 0, '']}
            />
            <Legend />
            <Area type="monotone" dataKey="signups" name="Signups" stroke="#006175" fill="#00617533" strokeWidth={2} />
            <Area type="monotone" dataKey="premium_conversions" name="Premium" stroke="#28a745" fill="#28a74533" strokeWidth={2} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default GrowthChart;
